<template>
    <div>
        <span @click="getAccount()">
            <Button type="primary" @click="modal = true" v-hasPermission="['patchManagement:policies:add_policy']">{{$t('PatchEasy.PatchPolicy.addStrategy')}}</Button>
        </span>
        <Modal v-model="modal" :title="$t('patch_management.patch_policy.addPolicy')" :mask-closable="false">
            <Form ref="policyForm" :model="policyForm" :rules="ruleValidate" :label-width="100" >
                <FormItem :label="$t('patch_management.patch_policy.name')" prop="name">
                    <Input v-model="policyForm.name" placeholder="" style="width:300px;"></Input>
                </FormItem>
                <FormItem :label="$t('patch_management.patch_policy.account')" prop="accountId">
                    <Select v-model="policyForm.accountId" filterable style="width:300px;" @on-change="changeAccountId(policyForm.accountId)" placeholder="">
                        <Option :value="item.id" v-for="(item,index) in accountList" v-bind:key="index">{{item.name}}</Option>
                    </Select>
                </FormItem>
                <FormItem :label="$t('patch_management.patch_policy.region')" prop="regionSearchKey">
                    <Select v-model="policyForm.regionSearchKey" filterable placeholder="" :transfer="true" style="width:300px;" >
                        <Option :value="item.name" v-for="item in regionList" :key="item.id">{{item.name}}</Option>
                    </Select>
                </FormItem>
                <FormItem :label="$t('patch_management.patch_policy.state')" prop="state">
                    <Select v-model="policyForm.state" filterable style="width:300px;" placeholder="">
                        <Option :value="item.state" v-for="item in statusList" v-bind:key="item.id">{{item.name}}</Option>
                    </Select>
                </FormItem>

                <!-- 提醒时间 -->
                <FormItem :label="$t('patch_management.patch_policy.remindTime')" prop="remindTime">
                    <Select v-model="policyForm.remindTime" filterable multiple style="width:300px;" @on-change="changeRemindTime(policyForm.remindTime)" placeholder="">
                        <Option :value="item.id" v-for="(item,index) in remindTimeList" v-bind:key="index">{{item.name}}</Option>
                    </Select>
                </FormItem>

                <div v-if="policyForm.remindTime!=''">
                    <!-- 联系方式 -->
                    <FormItem :label="$t('patch_management.patch_policy.contactType')" prop="contactType">
                        <RadioGroup v-model="policyForm.contactType" @on-change="changeContactType(policyForm.contactType)">
                            <Radio v-for="item in contactTypeList" :label="item.type" :key="item.value">{{item.label}}</Radio>
                        </RadioGroup>
                    </FormItem>

                    <!-- 通知对象 -->
                    <FormItem :label="$t('patch_management.patch_policy.contactPerson')" prop="notificationObject" v-if="policyForm.remindTime!=''&&policyForm.contactType==0">
                        <Select v-model="policyForm.notificationObject" filterable multiple style="width:300px;" placeholder="">
                          <Option v-for="item in notificationObjectList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                        </Select>
                    </FormItem>

                    <!-- 联系人组 -->
                    <FormItem :label="$t('patch_management.patch_policy.contactGroup')" prop="contactGroupId" v-if="policyForm.remindTime!=''&&policyForm.contactType==1">
                        <Select v-model="policyForm.contactGroupId" filterable style="width:300px;" placeholder="">
                            <Option v-for="item in contactGroupIdList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                        </Select>
                    </FormItem>
                </div>

                <!-- 审批流 -->
                <FormItem :label="$t('patch_management.patch_policy.approvalFlow')" prop="approvalFlow">
                    <Select v-model="policyForm.approvalFlow" filterable style="width:300px;" @on-change="changeApprovalFlow" placeholder="">
                        <Option :value="item.id" v-for="(item,index) in approvalFlowList" v-bind:key="index">{{item.name}}</Option>
                    </Select>
                </FormItem>
                <FormItem :label="$t('patch_management.patch_policy.schedule')" prop="scheduleNames">
                    <Select v-model="policyForm.scheduleNames" filterable style="width:300px;" placeholder="">
                        <Option :value="item.id" v-for="(item,index) in scheduleNameList" v-bind:key="index">{{item.name}}</Option>
                    </Select>
                </FormItem>
                <FormItem :label="$t('patch_management.patch_policy.description')" prop="describe">
                    <Input v-model="policyForm.describe" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="" style="width:300px;"></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="handleReset('policyForm')">{{$t('patch_management.patch_policy.cancel')}}</Button>
                <Button type="primary" @click="handleSubmit('policyForm')" :loading="loading">{{showDetermineName}}</Button>
            </div>
        </Modal>
    </div>
</template>
<script>

    import {setCookie,getCookie} from '../../../utils/cookieUtil.js'
    import TablePolicies from '../policy/TablePolicies.vue'
    var tablePolicies = TablePolicies;
    export default {
        data () {
            return {
                contactTypeList: [{
                    label: this.$t('patch_management.patch_policy.contactPerson'),
                    value: 'contact',
                    type: 0
                },
                {
                    label: this.$t('patch_management.patch_policy.contactGroup'),
                    value: 'contactGroup',
                    type: 1
                }],
                showDetermineName:this.$t('patch_management.patch_policy.confirm'),
                notificationObjectList: [],
                remindTimeList:[],
                policyForm: {
                    name: '',
                    accountId: '',
                    state: '0',
                    textarea: '',
                    regionSearchKey:'',
                    scheduleNames:'',
                    approvalFlow:'',
                    notificationObject: [],
                    remindTime:[],
                    contactType:0,
                    contactGroupId:''
                },
                // 联系人组
                contactGroupIdList:[],
                approvalFlowList:[],
                accountList:[],
                regionList:[], //区域
                scheduleNameList: [],
                statusList: [{
                    id: 1,
                    name:this.$t('alarms.common.enable'),
                    state: 0
                },
                {
                    id: 2,
                    name: this.$t('alarms.common.disable'),
                    state: 1
                }],
                modal: false,
                loading: false,
                ruleValidate: {
                    name: [
                        { required: true, message: this.$t('patch_management.patch_policy.nameRequired'), trigger: 'blur' },
                        { type: 'string', message: this.$t('patch_management.patch_policy.nameLength'), pattern:'^.{4,20}$', trigger: 'blur'}
                    ],
                    approvalFlow: [
                        { required: false, message: this.$t('patch_management.patch_policy.selectApprovalFlow'), trigger: 'change', type: 'number' }
                    ],
                    notificationObject: [
                        {required: true, type: 'array', message: this.$t('patch_management.patch_policy.selectNotificationObject'), trigger: 'change'}
                    ],
                    accountId: [
                        { required: true, message: this.$t('patch_management.patch_policy.selectAccountName'), trigger: 'change',type:'number' }
                    ],
                    remindTime: [
                        { required: false, message: this.$t('patch_management.patch_policy.selectRemindTime'), trigger: 'change',type:'array' }
                    ],
                    state: [
                        { required: true, message: this.$t('patch_management.patch_policy.selectState'), trigger: 'change' ,type:'number'}
                    ],
                    scheduleNames: [
                        { required: true, message: this.$t('patch_management.patch_policy.selectSchedule'), trigger: 'change',type:'number' }
                    ],
                    describe: [
                        { required: false, message: this.$t('common.descriptionRequired'), trigger: 'blur' },
                        { type: 'string', max: 100, message: this.$t('patch_management.patch_policy.maxChars100'), trigger: 'blur' }
                    ],
                    regionSearchKey: [
                        { required: true, message: this.$t('RAM.common.PleaseSelectRegion'), trigger: 'change' }
                    ],
                    contactType: [
                        {required: true, message: this.$t('patch_management.patch_policy.selectContactType'), trigger: 'change', type: 'number'}
                    ],
                    contactGroupId: [
                        {required: true, message: this.$t('patch_management.patch_policy.selectContactGroup'), trigger: 'change', type: 'number'}
                    ]
                }
            }
        },
        methods:{
            // 审批流
            selectListNames:function(){
                this.$api.processTemplate.selectListNames({
                    "type":1
                })
                .then(res => {
                    this.approvalFlowList = res.data;
                })
            },
            // 根据用户名查询Account列表
            queryAccountsByUsername: function(){
                //根据用户名查询Account列表
                this.$api.account.selectAccountByCloudPlatform("type",0)
                    .then(res => {
                        this.accountList = res.data;
                    })
            },
            // 区域
            queryAccountRegions:function(){
                if (this.policyForm.accountId == "" || this.policyForm.accountId == null ) {
                    return;
                }
                this.$api.account.queryAccountRegions("accountId",this.policyForm.accountId)
                    .then(res => {
                        this.regionList = res.data;
                    })
            },
            // 切换账户
            changeAccountId: function(){
                this.queryAccountRegions();
            },
            // 切换联系方式
            changeContactType:function(){
                if(this.policyForm.contactType===1){
                    this.$api.contactGroup.listContactGroups()
                    .then(res => {
                        this.contactGroupIdList = res.data;
                    })
                }
            },
            // 根据UserName返回Schedule列表
            getAccount: function(){
                this.showDetermineName=this.$t('patch_management.patch_policy.confirm');
                this.selectListNames();
                this.getRemindTime();
                this.queryAccountsByUsername();
                this.$api.scheduleManagement.querySchedulesByUserName("userName",getCookie(global.cookieName))
                    .then(res => {
                        this.scheduleNameList = res.data;
                    })
            },
            // 提醒时间
            getRemindTime:function(){
                this.$api.policy.getRemindTime("userName",getCookie(global.cookieName))
                .then(res => {
                    this.remindTimeList = res.data;
                })
            },
            // 切换提醒时间
            changeRemindTime:function(){
                if(this.policyForm.remindTime.length===0){
                    this.policyForm.notificationObject=[];
                }
                this.$api.contact.queryContacts("monitorModule", 22)
                .then(res => {
                    this.notificationObjectList = res.data.contactList;
                })
            },
            // 切换审批流
            changeApprovalFlow:function(){
                // 如果不选审批流 显示确定 否则显示提交
                if(this.policyForm.approvalFlow==''){
                    this.showDetermineName=this.$t('patch_management.patch_policy.confirm')
                }else{
                    this.showDetermineName=this.$t('patch_management.patch_policy.submit')
                }
            },
            handleSubmit: function(name) {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.loading = true;
                        var policyData={
                            "name": this.policyForm.name,
                            "accountId": this.policyForm.accountId,
                            "region":this.policyForm.regionSearchKey,
                            "scheduleManagementId": this.policyForm.scheduleNames,
                            "description": this.policyForm.describe,
                            "state": this.policyForm.state,
                            "reminds": this.policyForm.remindTime,
                            "processTemplateId":this.policyForm.approvalFlow,
                            "contactType":this.policyForm.contactType
                        };

                        // 如果联系方式是联系人 传通知对象
                        if(this.policyForm.contactType == 0){
                            policyData.contactIDs = this.policyForm.notificationObject;
                        }
                        // 如果联系方式是联系人组 传联系人组
                        else if(this.policyForm.contactType == 1){
                            policyData.contactGroupId = this.policyForm.contactGroupId;
                        }

                        this.$api.policy.createPolicy(policyData)
                        .then(res => {
                            this.data = res.data;
                            setTimeout(() => {
                                tablePolicies.methods.showAll();
                                this.$refs[name].resetFields();//清空表格内的我们填写的数据
                                this.loading = false;
                                this.$Message.success(this.$t('common.addSuccess'));
                                this.regionList=[];
                                this.modal = false;
                            }, 1000);
                        })
                    }
                    else{
                        //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
                        this.loading = false;
                        this.$Message.error(this.$t('common.addFail'));
                    }
                });
            },
            handleReset: function(name) {
                this.modal = false;
                this.loading = false;
                this.regionList=[];
                this.notificationObjectList=[];
                this.$refs[name].resetFields();
            }
        }
    }
</script>
<style scoped>
    .addPolicies-main
    {
        width: 300px;
        min-height: 100px;
        border: 1px solid #dcdee2;
        border-radius: 4px;
    }
    .addPolicies-main>div
    {
        margin-left: 8px;
    }
</style>



// WEBPACK FOOTER //
// src/components/patch_management/policy/AddPolicies.vue